<template>
    <div class="qingwu">
        <el-form  label-width="100px" ref="info" :model="info">
          <el-form-item label-width="160px" label="每天拼团次数" prop="pintcs" :rules="[{required:true,message:'不能为空',trigger: 'blur' }]"><el-input type="number" class="spec_group_input" v-model="info.pintcs" placeholder="0"><template slot="append">次数</template></el-input></el-form-item>
            <el-form-item label-width="160px" label="备注："><el-tag type="info">每天拼团次数</el-tag></el-form-item>
            <el-form-item label-width="160px">
                <el-button type="primary" @click="submitForm('info')">提交</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
      return {
          info:{
              logo:''
          },
          upload_headers:{},
          logo:''
      };
    },
    watch: {},
    computed: {},
    methods: {
        handleAvatarSuccess(res) {
            this.info.logo = res.data;
            this.$forceUpdate();
        },
        submitForm:function(e){
            this.$refs[e].validate(res=>{
                if(res){
                    // Http 请求
                    this.$post(this.$api.pintcsConfig,this.info).then(postRes=>{
                        if(postRes.code == 200){
                            this.$message.success("编辑成功");
                            this.get_alipaypc_config();
                        }else{
                            this.$message.error("编辑失败");
                        }
                    });
                }
            });
        },
        get_alipaypc_config(){
            this.$get(this.$api.pintcsConfig).then(res=>{
                if(res.data != null){
                    this.info  = res.data;
                }
            });
        },
    },
    created() {
        this.get_alipaypc_config();
        this.upload_headers.Authorization = 'Bearer '+localStorage.getItem('token'); // 要保证取到
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>

</style>